var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgElectricity = function SvgElectricity(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m8.751 18.26 2.068-4.823a.383.383 0 0 0-.352-.533H8.955a.381.381 0 0 1-.352-.535l2.342-5.357a.383.383 0 0 1 .35-.23h3.93a.382.382 0 0 1 .298.623l-2.066 2.583a.382.382 0 0 0 .298.621h1.726a.383.383 0 0 1 .27.654l-7 6.998Z"
  })));
};

export default SvgElectricity;